import { useContext, useEffect, useRef } from "react";
import MainStateContext from "../../state/mainStateContext";
import "../../assets/css/overlay.css";
import { triggerEvent, wvusLogger } from "../../helpers";
import { StateContextType } from "../../types";
import { getPhrase } from "../../languages";

type Props = {
  maxTimeout?: number;
};

export const Overlay = (props: Props) => {
  const { maxTimeout = 45 * 1000 } = props;
  const timeoutRef = useRef(null);
  const { state, toggleOverlay, setSubmitMessagePhraseKey } = useContext(
    MainStateContext
  ) as StateContextType;
  const { appOverlayActive, submitMessagePhraseKey } = state;

  useEffect(() => {
    if (appOverlayActive && !timeoutRef?.current) {
      timeoutRef.current = setTimeout(() => {
        setSubmitMessagePhraseKey("errors.general_error_volunteer");

        const errorDetail = `overlay timed out after ${maxTimeout}ms`;

        wvusLogger.log(`AppOverlay error: ${errorDetail}`, wvusLogger.getLogLevelNames().ERROR);

        triggerEvent("error_view", {
          error_message: getPhrase("errors.general_error_volunteer"),
          error_type: "app_overlay_error",
          event_label: errorDetail,
          checkout_type: state?.products?.length
            ? `flex_checkout:${state.products[0].sku}`
            : "flex_checkout"
        });
      }, maxTimeout);
    }
  }, [timeoutRef, appOverlayActive]);

  useEffect(() => {
    if (submitMessagePhraseKey.length) {
      timeoutRef?.current && clearTimeout(timeoutRef.current);
      toggleOverlay(false);
    }
  }, [submitMessagePhraseKey]);

  if (!appOverlayActive) {
    // Clear Timeout and Remove Overlay
    timeoutRef?.current && clearTimeout(timeoutRef.current);
    return null;
  }

  return (
    <div className="overlay">
      <div className="overlay-content">
        <div className="spinner--wv-star">
          <div className="double-bounce1"></div>
          <div className="double-bounce2"></div>
        </div>
      </div>
    </div>
  );
};

export default Overlay;
